import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import UserList from './UserList';
import UserDetail from './UserDetail';

@inject(({ commonStore, userInfoStore }) => ({
  commonStore: commonStore,
  sessionLoginInfo: commonStore.sessionLoginInfo,
  setCommonStoreInfo: userInfoStore.setCommonStoreInfo,
  
  onClear: userInfoStore.onClear,
  viewMode: userInfoStore.viewMode,
  onViewMode: userInfoStore.onViewMode,
  disUserList: userInfoStore.disUserList,
  disJobList: userInfoStore.disJobList,
}))
@observer
class UserContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disUserList(1);
    this.props.disJobList('', '', 'Y');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/userManage');
      } else {
        this.props.history.push('/userManage/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { sessionLoginInfo } = this.props;
    return (
      this.props.viewMode === 'list'
      ? <UserList 
          sessionLoginInfo={sessionLoginInfo}
        /> 
      : <UserDetail />
    );
  }

}

export default withRouter(UserContainer);
